import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Light.ttf%22,%22weight%22:%22300%22},{%22path%22:%22../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Book.otf%22,%22weight%22:%22350%22,%22style%22:%22normal%22},{%22path%22:%22../../../../public/fonts/brand/stylein/CircularStd/CircularStd-BookItalic.otf%22,%22weight%22:%22350%22,%22style%22:%22italic%22},{%22path%22:%22../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Medium.otf%22,%22weight%22:%22400%22},{%22path%22:%22../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Bold.otf%22,%22weight%22:%22700%22}],%22variable%22:%22--brand-font%22}],%22variableName%22:%22circularStdFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'circularStdFont', 'circularStdFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
